module.exports = __webpack_public_path__ + "static/media/pie_chart.fw.8cc73faf.png";